import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'PushMessageUserEdit',
  data: function data() {
    return {
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      imageUrl: '',
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      fileList: [],
      title: '',
      form: {
        id: null,
        name: '',
        image: '',
        type: null,
        createTime: null
      },
      rules: {
        id: [{
          required: true,
          message: '请输入标识ID',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入账户名称',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          message: '请输入显示头像',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请输入账户类型',
          trigger: 'blur'
        }],
        createTime: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = this.downUrl + res.body.url;
      this.form.image = res.body.url;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData(type) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.id = null;
      this.form.name = null;
      this.form.image = null;
      this.form.createTime = null;
      this.form.type = type;
      this.imageUrl = '';
      this.initNetData();
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.id = data.id + '';
      this.form.name = data.name;
      this.form.image = data.image;
      this.form.type = data.type + '';
      this.form.createTime = data.createTime + '';
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_PUSHMESSAGEUSER(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_PUSHMESSAGEUSER(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('保存成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    initNetData: function initNetData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res, item;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                type: _this4.form.type
              };
              _context4.n = 1;
              return api.GET_PUSHMESSAGEUSER_LIST(par);
            case 1:
              res = _context4.v;
              if (res.body.length > 0) {
                item = res.body[0];
                _this4.form.name = item.name;
                _this4.form.image = item.image;
                _this4.imageUrl = _this4.downUrl + item.image;
                _this4.form.type = item.type + '';
                _this4.form.createTime = item.createTime + '';
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this5 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this5.form.id != null) {
            _this5.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this5.updateApi();
            }).catch(function () {
              _this5.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this5.saveApi();
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};